import { React, useEffect, useState } from "react";
import { Modal, TextField, MenuItem, Fade, InputAdornment } from "@mui/material";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";

const EditarModeloModal = ({ open, onClose, id, nip, neconomico }) => {
    const [detalle, setDetalle] = useState([])

    const [openEditarModeloModal, setOpenEditarModeloModal] = useState(open);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [modelo, setModelo] = useState('');

    const handleClose = () => {
        setOpenEditarModeloModal(false);
        onClose();
    };

    const onEditar = (id, nip, modelo) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `ListadoFacturacionMaquinaria/Editar?id=${id}&nip=${nip}&modelo=${modelo}&usuario=0`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "DETALLE DE FACTURACION",
                    "Facturación Editada con Éxito",
                    "success"
                );
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("DETALLE DE FACTURACION", JSON.stringify(error), "error");
                return;
            });
    }

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <>
            <LoaderScreen loader={loader} />
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropProps={{
                    timeout: 300,
                }}
            >
                <Fade in={open}>
                    <div className="plantilla-screen-filtro-container-modal-container">
                        <div className="editar-modelo-modal">
                            <div className="editar-modelo-modal-detalle">
                                <div className="editar-modelo-modal-detalle-formulario">
                                    <div className="editar-modelo-modal-formulario-plantilla">
                                        <div
                                            className="plantilla-screen-filtro-container"
                                            id="mdlFiltros-modal"
                                        >
                                            <PlantillaScreen
                                                titulo={`EDITAR MODELO DE FACTURACION`}
                                                className_main={1}
                                                className={"plantilla-screen-filtro-container-modal"}
                                            >
                                                <div className="cerrar-modal-button" onClick={onClose}>
                                                    X
                                                </div>
                                                <div
                                                    className={`editar-modelo-modal-formulario-plantilla-agregar`}
                                                >
                                                    <div className="editar-modelo-modal-formulario-plantilla-container scroll-4">
                                                        <div className="editar-modelo" style={{ width: '100%' }}>
                                                            <TextField
                                                                id="neconomico"
                                                                size="small"
                                                                label="No. Económico"
                                                                variant="outlined"
                                                                type="text"
                                                                inputProps={{
                                                                    style: { textAlign: "left" },
                                                                    readOnly: true,
                                                                }}
                                                                value={neconomico || ""}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start"></InputAdornment>
                                                                    ),
                                                                }}
                                                                fullWidth
                                                                sx={{ mt: 2 }} // Espaciado superior
                                                            />
                                                            <TextField
                                                                id="nip"
                                                                size="small"
                                                                label="NIP"
                                                                variant="outlined"
                                                                type="text"
                                                                inputProps={{
                                                                    style: { textAlign: "left" },
                                                                    readOnly: true,
                                                                }}
                                                                value={nip || ""}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start"></InputAdornment>
                                                                    ),
                                                                }}
                                                                fullWidth
                                                                sx={{ mt: 2 }} // Espaciado superior
                                                            />
                                                            <TextField
                                                                id="outlined-multiline-static"
                                                                label="Modelo"
                                                                value={modelo}
                                                                onChange={(e) => {
                                                                    setModelo(e.target.value);
                                                                }}
                                                                fullWidth
                                                                sx={{ mt: 2 }} // Espaciado superior
                                                            />
                                                        </div>
                                                        <div className="editar-modelo-modal-buttons">
                                                            <button
                                                                className="editar-modelo-modal-button-guardar"
                                                                onClick={() => onEditar(id, nip, modelo)}
                                                            >
                                                                Guardar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </PlantillaScreen>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </>
    );
};

export default EditarModeloModal;